import { createItemSet } from 'tabview/visualizations/aq-blocks/itemSet';
import type {
  BlocksGraph,
  BlocksNode,
  BlocksReference,
} from 'tabview/visualizations/aq-blocks/types';

/**
 * The trace items, their directly incident references, and their immediate neighbour nodes.
 */
export const collectOneHopTrace = (
  graph: BlocksGraph | null,
  nodes: Iterable<BlocksNode>,
  references: Iterable<BlocksReference>
) => {
  const traced = createItemSet(0);

  if (graph) {
    for (const reference of references) {
      traced.add(reference);
      traced.add(reference.source);
      traced.add(reference.target);
    }

    for (const node of nodes) {
      traced.add(node);

      if (node.links) {
        for (const reference of node.links) {
          traced.add(reference);
          traced.add(reference.source);
          traced.add(reference.target);
        }
      }
    }
  }

  return traced.size !== 1 ? traced : createItemSet(0);
};
